<div class="loading-overlay" >
	<progress
		class="progress" [attr.value]="progressValue" [attr.max]="maxProgressValue"
		[ngClass]="{'is-progress-visible':loading, 'is-progress-hidden':!loading}"></progress>
</div>
